<template>
    <div class="templete_box">
        <div class="crumbsNav no_print clearfix">
            <div :class="['navSon',tab==1?'navSonChecked':'']" @click="changeTab(1)">
                组装拆卸
            </div>
            <div :class="['navSon',tab==2?'navSonChecked':'']" @click="changeTab(2)" v-if="transferType">
                货物转库
            </div>
            <div :class="['navSon',tab==3?'navSonChecked':'']" @click="changeTab(3)"  v-if="flipType" >
                翻包加工
            </div>
        </div>
        <Assmbly v-if="tab == 1"></Assmbly>
        <Transfer v-if="tab == 2"></Transfer>
        <Tilting v-if="tab == 3"></Tilting>
        <!-- <div class="crumbsNav clearfix no_print">
             <navTab
                :navlist="navlist"
                @reback="
                    (res) => {
                    this.tab = res;
                    }
                "
                ></navTab>
        </div> -->
        <!-- <div class="templete">
            <Assmbly v-if="tab == 0"></Assmbly>
            <Transfer v-if="tab == 1&& module.indexOf(',warehouse-stock-transfer,')!=-1"></Transfer>
            <Tilting v-if="tab ==2"></Tilting>
        </div> -->
    </div>
</template>
<style scoped lang="scss">
    .container{
        padding: 15px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2; overflow: auto;
        .tabs{
            display: flex; align-items: center; margin-bottom: 23px;
            .item {
                font-size:16px; font-weight:bold; color: #333333; cursor: pointer; border-bottom: 2px solid transparent; padding-bottom: 5px;
                &.active{ border-bottom: 2px solid #B21111; color: #b21111; }
            }
            .item + .item{ margin-left: 30px; }
        }
        .tab_content{ flex: 1; display: flex; flex-direction: column; height: 100%; overflow: hidden; }
    }
    .navSon{padding:0 0px;font-size: 14px;line-height: 30px;float: left;margin-right:80px;}
    .navSonChecked{color: #B21111;}
</style>
<script>
    import Assmbly from '../assembly.vue'
    import Transfer from '../transfer.vue'
    import Tilting from '../tilting.vue'
    export default {
        components:{
            Assmbly,
            Transfer,
            Tilting
        },
        data(){
            return{
                module:localStorage.dw_erp_power_code, 
                transferType:localStorage.dw_erp_power_code.indexOf(',warehouse-stock-transfer,')!=-1?true:false,
                flipType:localStorage.dw_erp_power_code.indexOf(',warehouse-stock-flip,')!=-1?true:false,
                tab: 1,
            }
        },
        created() {

        },
        methods: {
            changeTab(tab){
                this.$set(this,"tab",tab);
            },
        },
    }
</script>
